/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForRecoveryConfiguration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForRecoveryConfiguration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForRecoveryConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForRecoveryConfiguration>): BackgroundJobPayloadForRecoveryConfiguration {
        let obj = Object.assign(new BackgroundJobPayloadForRecoveryConfiguration(), model);
        BackgroundJobPayloadForRecoveryConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForRecoveryConfiguration>): BackgroundJobPayloadForRecoveryConfiguration {
        if (!model) return null;
        return BackgroundJobPayloadForRecoveryConfiguration.newInstance(<BackgroundJobPayloadForRecoveryConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForRecoveryConfiguration) {
        if (!obj) return;

        models.BackgroundJobPayloadForRecoveryConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForRecoveryConfiguration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForRecoveryConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

}
